import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { useParams } from "react-router-dom"
//import components
import Breadcrumbs from "../../components/Common/Breadcrumb"


import {
  Col,
  Row,
  Card,
  CardBody,
} from "reactstrap"
import {
  fetchAppointmentsBasedOnId,
} from "helpers/api_helper"
// import "./style.scss"
import AppointmentDetailsCard from "./components/AppointmentDetailsCard"
// import PetCompleteDetails from "./components/PetCompleteDetails"

function AppointmentDetails() {
  //meta title
  document.title = "Appointment Details | Supaw"

  const [itemDetails, setItemDetails] = useState({})
  const [noDetails, setNoDetails] = useState(false)

  const [parentPets, setParentPets] = useState([])

  const [verticalActiveTab, setverticalActiveTab] = useState("1")

  const { itemId } = useParams()

  // fetchAppointmentsListBasedOnPetId
  // const toggleVertical = tab => {
  //   if (verticalActiveTab !== tab) {
  //     setverticalActiveTab(tab)
  //   }
  // }
  const fetchData = async () => {
      try {
        const detail = await fetchAppointmentsBasedOnId(itemId)
        if (detail?.status === 1 && detail?.data?._id) {
          setItemDetails(detail.data)
          setNoDetails(false)

        // const petList = await getAllPetsByParentId(id)
        // setParentPets(petList.data)
        // setverticalActiveTab(petList.data[0]._id)
        } else {
          setNoDetails(true)
        }
      } catch (error) {
        setNoDetails(true)
      }
  }

  useEffect(() => {
    fetchData()
  }, [itemId])


  if (noDetails) {
    return (
      <React.Fragment>
        <div className="page-content">
          <div className="container-fluid">
            <Breadcrumbs
              title="Appointment History"
              breadcrumbItem="Appointment Details"
            />
            <Row>
              <Col xs="12">
                <h3>Appointment details are unavailable.</h3>
              </Col>
            </Row>
          </div>
        </div>
      </React.Fragment>
    )
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs
            title="Appointment History"
            titleLink="/appointments"
            breadcrumbItem={itemDetails?.petObjectId?.fullName}
          />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <AppointmentDetailsCard
                    testDetails={itemDetails ? itemDetails : {}}
                  />
                  {/* <div className="parent-details__container">
                    <Row>
                      <Col md="3">
                        <CardBody>
                          <CardTitle className="mb-4">
                            {itemDetails.fullName} Pet (s) (
                            {parentPets?.length})
                          </CardTitle>
                          <Nav pills className="flex-column">
                            {parentPets?.length
                              ? parentPets.map((item, index) => {
                                  return (
                                    <NavItem key={index}>
                                      <NavLink
                                        style={{ cursor: "pointer" }}
                                        className={classnames({
                                          "mb-2": true,
                                          active:
                                            verticalActiveTab === item._id,
                                        })}
                                        onClick={() => {
                                          toggleVertical(item._id)
                                        }}
                                      >
                                        {item.fullName}
                                        {item.images[0] && (
                                          <img src={BASE + item.images[0]} />
                                        )}
                                      </NavLink>
                                    </NavItem>
                                  )
                                })
                              : null}
                          </Nav>
                        </CardBody>
                      </Col>
                      <Col md="9">
                        <TabContent
                          activeTab={verticalActiveTab}
                          className="text-muted mt-4 mt-md-0"
                        >
                          {parentPets?.length ? (
                            parentPets.map((item, index) => {
                              return (
                                <TabPane key={index} tabId={item._id}>
                                  <PetCompleteDetails petDetails={item} />
                                </TabPane>
                              )
                            })
                          ) : (
                            <div className="history-doc-cta mb-4 ">
                              <Link
                                className="btn btn-secondary"
                                to={`/add-pet/parent/${itemDetails?._id}`}
                              >
                                + Add Pets
                              </Link>
                            </div>
                          )}
                        </TabContent>
                      </Col>
                    </Row>
                  </div> */}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  )
}
AppointmentDetails.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
}

export default AppointmentDetails
